import axios from 'axios';
import { useState } from 'react';
import stylez from './forgotPwd.module.css';
import { BASE_URL } from '../../../Configuration/baseUrls';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    e.preventDefault();
    setEmail(e.target.value);
    // Clear error message when the user starts typing
    setError('');
  };

  const validateEmail = (email) => {
    // Simple email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const submit = async () => {
    // Check for empty email
    if (!email.trim()) {
      setError('Email cannot be empty');
      return;
    }

    // Check if it's a valid email
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      const res = await axios.post(`${BASE_URL}user/forgotPwd`, { email });
      setMsg(res.data.message);
      setError('');
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.message);
      }
    }
  };

  return (
    <div className={stylez.fotgotPWDContainer}>
      <div className={stylez.forgotPWD}>
        <h1>Firebrand BBQ ERP</h1>
        <div>
          <label>Enter Email Address:</label>
          <input
            type='email'
            placeholder='Email'
            name='email'
            value={email}
            required
            onChange={handleChange}
          />
          <button className={stylez.submitBtn} onClick={submit}>
            Submit
          </button>
          {error && <div className={stylez.errorMsg}>❗{error}</div>}
          {msg && <div className={stylez.successMsg}>✅{msg}</div>}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
